import type { OrganizationBrand } from "../context/SessionContext.js";

/** External destination rendered in the left nav's quick links section. */
export interface QuickLink {
  label: string;
  href: string;
  icon: "hub" | "reagan" | "discord";
}

/** Tooling every white label shares. */
const SHARED_QUICK_LINKS: QuickLink[] = [
  { label: "Reagan.ai", href: "https://reagan.ai", icon: "reagan" },
  { label: "Discord", href: "https://discord.com/app", icon: "discord" },
];

/**
 * Quick links per organization, keyed by slug. An organization's own hub goes
 * first, then the shared tooling. Organizations absent from this map render no
 * quick links section at all.
 */
const QUICK_LINKS_BY_SLUG: Record<string, QuickLink[]> = {
  "epic-life": [
    { label: "Epic Life Agent Hub", href: "https://epiclifeagenthub.com", icon: "hub" },
    ...SHARED_QUICK_LINKS,
  ],
  // No Ark Life agent hub exists yet, so they get the shared tooling only.
  "ark-life-group": [...SHARED_QUICK_LINKS],
};

/** Stable ids, so a renamed slug cannot silently drop an organization's links. */
const SLUG_BY_ORGANIZATION_ID: Record<string, string> = {
  org_epic_life: "epic-life",
  org_ark_life_group: "ark-life-group",
};

/** Quick links are organization-scoped; organizations without any render no section. */
export function resolveQuickLinks(organization?: OrganizationBrand | null): QuickLink[] {
  if (!organization) return [];
  const slug = SLUG_BY_ORGANIZATION_ID[organization.id] ?? organization.slug;
  return QUICK_LINKS_BY_SLUG[slug] ?? [];
}
